import { render } from "./Cart_Article_Item.vue?vue&type=template&id=487db991&scoped=true"
import script from "./Cart_Article_Item.vue?vue&type=script&lang=js"
export * from "./Cart_Article_Item.vue?vue&type=script&lang=js"

import "./Cart_Article_Item.vue?vue&type=style&index=0&id=487db991&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487db991"]])

export default __exports__